var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitaminB12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 384,
    viewBox: "0 0 340 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.537 237.385L246.096 254.913C239.029 261.632 239.029 272.634 246.096 279.352C253.179 286.07 264.74 286.07 271.822 279.352L290.247 261.824L281.355 248.033L264.537 237.385ZM264.537 83.6221L246.096 101.135C239.029 107.868 239.029 118.856 246.096 125.589C253.179 132.306 264.74 132.306 271.822 125.589L290.247 108.061L281.027 93.4543L264.537 83.6221ZM264.537 160.496L246.096 178.024C239.029 184.742 239.029 195.745 246.096 202.462C253.179 209.195 264.74 209.195 271.822 202.462L290.247 184.949L282.665 171.38L264.537 160.496Z",
    fill: "#80B4FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.276 283.195C258.813 285.642 266.566 284.352 271.824 279.354L290.249 261.826L283.572 255.479L258.454 279.354C256.644 281.075 254.538 282.365 252.276 283.195ZM252.276 129.432C258.813 131.864 266.566 130.589 271.824 125.591L290.249 108.064L283.572 101.717L258.454 125.591C256.644 127.312 254.538 128.587 252.276 129.432ZM252.276 206.321C258.813 208.753 266.566 207.463 271.824 202.465L290.249 184.952L283.572 178.605L258.454 202.465C256.644 204.201 254.538 205.476 252.276 206.321Z",
    fill: "#61A2F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.687 219.861C301.621 213.143 290.045 213.143 282.977 219.861L264.536 237.389L290.247 261.827L308.687 244.299C315.77 237.582 315.77 226.579 308.687 219.861ZM308.687 66.0984C301.621 59.3657 290.045 59.3657 282.977 66.0984L264.537 83.6259L290.247 108.064L308.688 90.5364C315.77 83.8189 315.77 72.8159 308.687 66.0984ZM308.687 142.972C301.621 136.254 290.045 136.254 282.977 142.972L264.536 160.5L290.247 184.953L308.687 167.425C315.77 160.693 315.77 149.705 308.687 142.972Z",
    fill: "#F37C7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.688 219.859C303.43 214.862 295.692 213.587 289.155 216.019C291.418 216.849 293.524 218.139 295.334 219.859C302.401 226.577 302.401 237.58 295.334 244.298L283.571 255.478L290.248 261.826L308.688 244.298C315.771 237.58 315.771 226.577 308.688 219.859ZM308.688 66.0966C303.43 61.0992 295.692 59.8091 289.155 62.2412C291.418 63.086 293.524 64.3614 295.334 66.0966C302.401 72.8142 302.401 83.8177 295.334 90.5352L283.571 101.716L290.248 108.063L308.688 90.5352C315.771 83.8172 315.771 72.8142 308.688 66.0966ZM308.688 142.97C303.43 137.973 295.692 136.697 289.155 139.129C291.418 139.975 293.524 141.25 295.334 142.97C302.401 149.703 302.401 160.691 295.334 167.423L283.571 178.604L290.248 184.951L308.688 167.423C315.771 160.691 315.771 149.703 308.688 142.97Z",
    fill: "#E6646E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3154 81.6973H174.079V119.63H91.3154V81.6973Z",
    fill: "#80B4FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.727 81.6973H174.083V119.63H160.727V81.6973Z",
    fill: "#61A2F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3644 304H194.05C203.598 304 211.414 296.571 211.414 287.496V128.172C211.414 119.081 203.598 111.667 194.05 111.667H71.3644C61.8157 111.667 54 119.097 54 128.172V287.496C54 296.571 61.8008 304 71.3644 304Z",
    fill: "#CBE2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.695 304H194.05C203.598 304 211.414 296.571 211.414 287.496V128.172C211.414 119.081 203.598 111.667 194.05 111.667H180.695C190.242 111.667 198.059 119.081 198.059 128.172V287.496C198.059 296.571 190.242 304 180.695 304Z",
    fill: "#9DC6FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1224 89.6584H190.289C196.186 89.6584 200.991 85.0763 200.991 79.4709C200.991 73.8802 196.186 69.2981 190.289 69.2981H183.628V57.7463C183.628 50.1834 177.122 44 169.166 44H96.2464C88.2909 44 81.7686 50.1839 81.7686 57.7463V69.2986H75.1224C69.2253 69.2986 64.4053 73.8807 64.4053 79.4714C64.4053 85.0763 69.2253 89.6584 75.1224 89.6584Z",
    fill: "#CBE2FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.938 89.6584H190.291C196.189 89.6584 200.993 85.0763 200.993 79.4856C200.993 73.8802 196.189 69.2981 190.291 69.2981H183.63V57.7463C183.63 50.1834 177.125 44 169.168 44H155.812C163.77 44 170.275 50.1839 170.275 57.7463V63.337C170.26 67.4891 172.584 69.3724 176.937 69.2986C182.818 69.2986 187.639 73.8807 187.639 79.4861C187.639 85.0763 182.818 89.6584 176.938 89.6584Z",
    fill: "#9DC6FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 151.273H153.83C164.97 151.273 174.081 159.933 174.081 170.522V245.127C174.081 255.714 164.97 264.39 153.83 264.39H54V151.273Z",
    fill: "#FED1A3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.477 151.273H153.83C164.97 151.273 174.082 159.933 174.082 170.522V245.127C174.082 255.714 164.97 264.39 153.83 264.39H140.477C151.615 264.39 160.726 255.715 160.726 245.127V170.522C160.726 159.933 151.615 151.273 140.477 151.273Z",
    fill: "#FFBC85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaminB12);
export default __webpack_public_path__ + "static/media/VitaminB12.5b51de4f2cb1d88803a015c60b2d4932.svg";
export { ForwardRef as ReactComponent };